"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _lodash = _interopRequireDefault(require("lodash"));

var _classnames = _interopRequireDefault(require("classnames"));

var _reactDropzone = _interopRequireDefault(require("react-dropzone"));

var _papaparse = _interopRequireDefault(require("papaparse"));

var _react = _interopRequireDefault(require("react"));

var _calicoUiKit = require("@calico/calico-ui-kit");

var _calicoUiUtilities = require("@calico/calico-ui-utilities"); // File Upload Well
// Wraps any content, and becomes a drag-and-drop target for file upload.


var FILE_MIME_TYPES = {
  image: {
    name: 'image',
    mimeTypes: ['image/gif', 'image/jpeg', 'image/png']
  },
  json: {
    name: 'JSON file',
    mimeTypes: ['application/json']
  },
  pdf: {
    name: 'PDF',
    mimeTypes: ['application/pdf']
  },
  table: {
    name: 'CSV/TSV',
    mimeTypes: ['text/csv', 'text/tab-separated-values']
  },
  text: {
    name: 'text file',
    mimeTypes: ['text/plain', 'application/rtf']
  }
};

var FileTypeNamesByMimeType = _lodash.default.reduce(FILE_MIME_TYPES, function (mimeTypeToCanonical, fileType, canonicalType) {
  _lodash.default.each(fileType.mimeTypes, function (mimeType) {
    mimeTypeToCanonical[mimeType] = canonicalType;
  });

  return mimeTypeToCanonical;
}, {});

function getFileTypeNameFromMimeType(mimeType) {
  return FileTypeNamesByMimeType[mimeType] || null;
}

var _ref = _react.default.createElement("div", null, "No file types specified, so no uploads allowed.");

var _ref4 = _react.default.createElement("br", null);

var FileUploadWell =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FileUploadWell, _React$Component);

  function FileUploadWell() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2.default)(this, FileUploadWell);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2.default)(this, (_getPrototypeOf2 = (0, _getPrototypeOf3.default)(FileUploadWell)).call.apply(_getPrototypeOf2, [this].concat(args)));
    _this.state = {
      acceptedFileTypeNames: [],
      acceptedMimeTypes: [],
      fileTypes: []
    };

    _this.generateMimeTypeList = function (accept) {
      var acceptedMimeTypes = [];
      var fileTypes = accept ? Array.isArray(accept) ? accept : [accept] : null;

      if (!fileTypes) {
        fileTypes = _this.props.fileMimeTypes;
      }

      var acceptedFileTypeNames = [];

      for (var f in fileTypes) {
        var canonicalTypeName = fileTypes[f];
        var fileType = _this.props.fileMimeTypes[canonicalTypeName];

        if (fileType) {
          acceptedFileTypeNames.push(fileType.name);
          acceptedMimeTypes = acceptedMimeTypes.concat(fileType.mimeTypes);
        }
      }

      _this.setState({
        acceptedMimeTypes: acceptedMimeTypes,
        acceptedFileTypeNames: acceptedFileTypeNames,
        fileTypes: fileTypes
      });
    };

    _this.handleFiles = function (files) {
      files.forEach(function (file) {
        if (_this.props.forUpload) {
          _this.returnProcessedItem({
            file: file
          });
        } else {
          getFileTypeNameFromMimeType(file.type) === 'image' && _this.processImageFile(file);
          getFileTypeNameFromMimeType(file.type) === 'json' && _this.processJsonFile(file);
          getFileTypeNameFromMimeType(file.type) === 'pdf' && _this.processPdfFile(file);
          getFileTypeNameFromMimeType(file.type) === 'table' && _this.processDelimitedValuesFile(file);
          getFileTypeNameFromMimeType(file.type) === 'text' && _this.processTextFile(file);
        }
      });
    };

    _this.processDelimitedValuesFile = function (file) {
      _papaparse.default.parse(file, {
        complete: function complete(results) {
          return _this.returnProcessedItem({
            name: file.name,
            type: 'table',
            data: results.data
          });
        }
      });
    };

    _this.processImageFile = function (file) {
      var reader = new FileReader();

      reader.onload = function (event) {
        _this.returnProcessedItem({
          name: file.name,
          type: 'image',
          data: event.target.result
        });
      };

      reader.readAsDataURL(file);
    };

    _this.processJsonFile = function (file) {
      var reader = new FileReader();

      reader.onload = function (event) {
        var nextJsonText = reader.result;

        try {
          var nextJson = JSON.parse(nextJsonText);

          _this.returnProcessedItem({
            name: file.name,
            type: 'json',
            data: nextJson
          });
        } catch (error) {
          console.log('A file you uploaded wasn’t valid JSON. Please check the file and try again.');
        }
      };

      reader.readAsText(file);
    };

    _this.processPdfFile = function (file) {
      var reader = new FileReader();

      reader.onload = function (event) {
        _this.returnProcessedItem({
          name: file.name,
          type: 'pdf',
          data: event.target.result
        });
      };

      reader.readAsDataURL(file);
    };

    _this.processTextFile = function (file) {
      var reader = new FileReader();

      reader.onload = function (event) {
        _this.returnProcessedItem({
          name: file.name,
          type: 'text',
          data: reader.result
        });
      };

      reader.readAsText(file);
    };

    _this.returnProcessedItem = function (item) {
      if (_lodash.default.isFunction(_this.props.onAccept)) {
        _this.props.onAccept(item);
      }
    };

    return _this;
  }

  (0, _createClass2.default)(FileUploadWell, [{
    key: "componentWillMount",
    value: function componentWillMount() {
      this.generateMimeTypeList(this.props.accept);
    }
  }, {
    key: "componentWillReceiveProps",
    value: function componentWillReceiveProps(nextProps) {
      if (!_lodash.default.isEqual(this.props.accept, nextProps.accept)) {
        this.generateMimeTypeList(nextProps.accept);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          className = _this$props.className,
          classNameOnDrag = _this$props.classNameOnDrag,
          disableClick = _this$props.disableClick,
          labelClassName = _this$props.labelClassName,
          showOnDrag = _this$props.showOnDrag,
          style = _this$props.style,
          styleOnDrag = _this$props.styleOnDrag;
      var _this$state = this.state,
          acceptedFileTypeNames = _this$state.acceptedFileTypeNames,
          acceptedMimeTypes = _this$state.acceptedMimeTypes;

      if (_lodash.default.size(acceptedMimeTypes) === 0) {
        return _react.default.createElement("div", {
          className: className,
          style: style
        }, children ? children : _ref);
      }

      var parentClassName = (0, _classnames.default)((0, _defineProperty2.default)({
        'file-upload-well relative transition-all-short': true
      }, className, className));
      var titlePrefix = disableClick ? 'Drag' : 'Click or drag';
      return _react.default.createElement(_reactDropzone.default, {
        accept: acceptedMimeTypes.join(','),
        className: "transition-all-short",
        onClick: !disableClick,
        onDropAccepted: this.handleFiles
      }, function (_ref2) {
        var _cx2;

        var getRootProps = _ref2.getRootProps,
            getInputProps = _ref2.getInputProps,
            isDragActive = _ref2.isDragActive;

        var renderDropzoneContent = function renderDropzoneContent(_ref3) {
          var isDragActive = _ref3.isDragActive;

          if (children) {
            return children;
          }

          return _react.default.createElement("h3", {
            className: "grey-l"
          }, _react.default.createElement(_calicoUiKit.Icon, {
            className: (0, _classnames.default)({
              'inline-block': true,
              'grey-xl': !isDragActive,
              'blue': !classNameOnDrag && isDragActive
            }),
            icon: "ios-cloud-upload-outline",
            style: {
              fontSize: '500%'
            }
          }), _ref4, _react.default.createElement("span", {
            className: (0, _classnames.default)({
              'inline-block': true,
              'blue': !classNameOnDrag && isDragActive
            })
          }, titlePrefix, " to upload ", (0, _calicoUiUtilities.oxfordJoinSingular)(acceptedFileTypeNames, 'or')));
        };

        return _react.default.createElement("section", (0, _extends2.default)({
          className: (0, _classnames.default)((_cx2 = {
            'file-upload-well padding-4 transition-all-short center-all bg-white rounded text-center': true
          }, (0, _defineProperty2.default)(_cx2, className, true), (0, _defineProperty2.default)(_cx2, classNameOnDrag, isDragActive), (0, _defineProperty2.default)(_cx2, 'absolute', children), (0, _defineProperty2.default)(_cx2, 'blue', !classNameOnDrag && isDragActive), _cx2)),
          style: (0, _extends2.default)({
            border: '1px dashed',
            borderColor: isDragActive ? _calicoUiKit.Colors['blue'] : _calicoUiKit.Colors['grey-xl']
          }, children && {
            bottom: '0',
            left: '0',
            right: '0',
            top: '0',
            zIndex: '101'
          }, style, isDragActive && styleOnDrag)
        }, getRootProps()), _react.default.createElement("input", getInputProps()), isDragActive && showOnDrag ? showOnDrag : renderDropzoneContent({
          isDragActive: isDragActive
        }));
      });
    }
  }]);
  return FileUploadWell;
}(_react.default.Component);

FileUploadWell.defaultProps = {
  accept: null,
  classNameOnDrag: null,
  disableClick: false,
  fileMimeTypes: FILE_MIME_TYPES,
  forUpload: false,
  onAccept: null,
  showOnDrag: null,
  styleOnDrag: null
};
var _default = FileUploadWell;
exports.default = _default;